import React from 'react'
import { SvgIcon } from '@mui/material'

export const HueIcon = () => (
  <SvgIcon
    viewBox="0 0 16 16"
    sx={{ height: '16px', width: '16px', color: 'white' }}
  >
    <g clipPath="url(#HueIconUrlA)">
      <path
        fill="#fff"
        d="m13.807 3.754-1.56-1.56a.664.664 0 0 0-.94 0l-2.08 2.08-.82-.807a.664.664 0 1 0-.94.94l.48.48L2.1 10.733a.327.327 0 0 0-.1.24v2.694a.33.33 0 0 0 .333.333h2.694a.313.313 0 0 0 .233-.1l5.847-5.846.48.48a.664.664 0 1 0 .94-.94l-.814-.814 2.08-2.08a.66.66 0 0 0 .014-.946Zm-9.194 8.913-1.28-1.28 5.374-5.373 1.28 1.28-5.374 5.373Z"
      />
    </g>
    <defs>
      <clipPath id="HueIconUrlA">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)
